const PREFIX = 'FEEDBACK_FORM'

export const FEEDBACK_FORM_PAGE_REQUEST = `${PREFIX}_PAGE_REQUEST`

export const FEEDBACK_FORM_SUBMIT_FEEDBACK = `${PREFIX}_SUBMIT_FEEDBACK`

export const FEEDBACK_FORM_INVALID_FEEDBACK = `${PREFIX}_INVALID_FEEDBACK`

export const FEEDBACK_FORM_SUCCESS_SUBMIT = `${PREFIX}_SUCCESS_SUBMIT`

export const FEEDBACK_FORM_SET_DATA_CHECK_FEEDBACK_TOKEN = `${PREFIX}_SET_DATA_CHECK_FEEDBACK_TOKEN`

export const FEEDBACK_FORM_SHOW_FORM = `${PREFIX}_SHOW_FORM`



// WEBPACK FOOTER //
// ./app/actions/feedbackForm/constants.js